/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UserQuizDto } from '../models';
// @ts-ignore
import type { UserQuizQuestionDto } from '../models';
// @ts-ignore
import type { UserQuizStateInfoDto } from '../models';
/**
 * RestUserQuizApi - axios parameter creator
 * @export
 */
export const RestUserQuizApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get user quiz question
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {GetUserQuizQuestionPositionEnum} position 
         * @param {boolean} [languageRefresh] true when the current question is fetched again only because the user switched the language; such a read does not count as another display of the question (quiz revisit) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuizQuestion: async (userId: string, userQuizId: string, position: GetUserQuizQuestionPositionEnum, languageRefresh?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserQuizQuestion', 'userId', userId)
            // verify required parameter 'userQuizId' is not null or undefined
            assertParamExists('getUserQuizQuestion', 'userQuizId', userQuizId)
            // verify required parameter 'position' is not null or undefined
            assertParamExists('getUserQuizQuestion', 'position', position)
            const localVarPath = `/api/users/{userId}/quizzes/{userQuizId}/questions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userQuizId"}}`, encodeURIComponent(String(userQuizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }

            if (languageRefresh !== undefined) {
                localVarQueryParameter['languageRefresh'] = languageRefresh;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get user quiz state
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuizState: async (userId: string, userQuizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserQuizState', 'userId', userId)
            // verify required parameter 'userQuizId' is not null or undefined
            assertParamExists('getUserQuizState', 'userQuizId', userQuizId)
            const localVarPath = `/api/users/{userId}/quizzes/{userQuizId}/state`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userQuizId"}}`, encodeURIComponent(String(userQuizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get user quizzes
         * @param {string} userId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuizzes: async (userId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserQuizzes', 'userId', userId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('getUserQuizzes', 'quizId', quizId)
            const localVarPath = `/api/users/{userId}/quizzes/{quizId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"quizId"}}`, encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary initialize user quiz
         * @param {string} userId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeUserQuiz: async (userId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('initializeUserQuiz', 'userId', userId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('initializeUserQuiz', 'quizId', quizId)
            const localVarPath = `/api/users/{userId}/quizzes/{quizId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"quizId"}}`, encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update quiz connection time
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuizConnectionTime: async (userId: string, userQuizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateQuizConnectionTime', 'userId', userId)
            // verify required parameter 'userQuizId' is not null or undefined
            assertParamExists('updateQuizConnectionTime', 'userQuizId', userQuizId)
            const localVarPath = `/api/users/{userId}/quizzes/{userQuizId}/connection`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userQuizId"}}`, encodeURIComponent(String(userQuizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUserQuizApi - functional programming interface
 * @export
 */
export const RestUserQuizApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUserQuizApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get user quiz question
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {GetUserQuizQuestionPositionEnum} position 
         * @param {boolean} [languageRefresh] true when the current question is fetched again only because the user switched the language; such a read does not count as another display of the question (quiz revisit) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserQuizQuestion(userId: string, userQuizId: string, position: GetUserQuizQuestionPositionEnum, languageRefresh?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserQuizQuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserQuizQuestion(userId, userQuizId, position, languageRefresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserQuizApi.getUserQuizQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get user quiz state
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserQuizState(userId: string, userQuizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserQuizStateInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserQuizState(userId, userQuizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserQuizApi.getUserQuizState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get user quizzes
         * @param {string} userId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserQuizzes(userId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserQuizDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserQuizzes(userId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserQuizApi.getUserQuizzes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary initialize user quiz
         * @param {string} userId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeUserQuiz(userId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserQuizDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeUserQuiz(userId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserQuizApi.initializeUserQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update quiz connection time
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuizConnectionTime(userId: string, userQuizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuizConnectionTime(userId, userQuizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserQuizApi.updateQuizConnectionTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUserQuizApi - factory interface
 * @export
 */
export const RestUserQuizApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUserQuizApiFp(configuration)
    return {
        /**
         * 
         * @summary get user quiz question
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {GetUserQuizQuestionPositionEnum} position 
         * @param {boolean} [languageRefresh] true when the current question is fetched again only because the user switched the language; such a read does not count as another display of the question (quiz revisit) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuizQuestion(userId: string, userQuizId: string, position: GetUserQuizQuestionPositionEnum, languageRefresh?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizQuestionDto> {
            return localVarFp.getUserQuizQuestion(userId, userQuizId, position, languageRefresh, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get user quiz state
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuizState(userId: string, userQuizId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizStateInfoDto> {
            return localVarFp.getUserQuizState(userId, userQuizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get user quizzes
         * @param {string} userId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuizzes(userId: string, quizId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserQuizDto>> {
            return localVarFp.getUserQuizzes(userId, quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary initialize user quiz
         * @param {string} userId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeUserQuiz(userId: string, quizId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizDto> {
            return localVarFp.initializeUserQuiz(userId, quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update quiz connection time
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuizConnectionTime(userId: string, userQuizId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateQuizConnectionTime(userId, userQuizId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUserQuizApi - interface
 * @export
 * @interface RestUserQuizApi
 */
export interface RestUserQuizApiInterface {
    /**
     * 
     * @summary get user quiz question
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {GetUserQuizQuestionPositionEnum} position 
     * @param {boolean} [languageRefresh] true when the current question is fetched again only because the user switched the language; such a read does not count as another display of the question (quiz revisit) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApiInterface
     */
    getUserQuizQuestion(userId: string, userQuizId: string, position: GetUserQuizQuestionPositionEnum, languageRefresh?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizQuestionDto>;

    /**
     * 
     * @summary get user quiz state
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApiInterface
     */
    getUserQuizState(userId: string, userQuizId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizStateInfoDto>;

    /**
     * 
     * @summary get user quizzes
     * @param {string} userId 
     * @param {string} quizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApiInterface
     */
    getUserQuizzes(userId: string, quizId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserQuizDto>>;

    /**
     * 
     * @summary initialize user quiz
     * @param {string} userId 
     * @param {string} quizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApiInterface
     */
    initializeUserQuiz(userId: string, quizId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizDto>;

    /**
     * 
     * @summary update quiz connection time
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApiInterface
     */
    updateQuizConnectionTime(userId: string, userQuizId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestUserQuizApi - object-oriented interface
 * @export
 * @class RestUserQuizApi
 * @extends {BaseAPI}
 */
export class RestUserQuizApi extends BaseAPI implements RestUserQuizApiInterface {
    /**
     * 
     * @summary get user quiz question
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {GetUserQuizQuestionPositionEnum} position 
     * @param {boolean} [languageRefresh] true when the current question is fetched again only because the user switched the language; such a read does not count as another display of the question (quiz revisit) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApi
     */
    public getUserQuizQuestion(userId: string, userQuizId: string, position: GetUserQuizQuestionPositionEnum, languageRefresh?: boolean, options?: RawAxiosRequestConfig) {
        return RestUserQuizApiFp(this.configuration).getUserQuizQuestion(userId, userQuizId, position, languageRefresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get user quiz state
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApi
     */
    public getUserQuizState(userId: string, userQuizId: string, options?: RawAxiosRequestConfig) {
        return RestUserQuizApiFp(this.configuration).getUserQuizState(userId, userQuizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get user quizzes
     * @param {string} userId 
     * @param {string} quizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApi
     */
    public getUserQuizzes(userId: string, quizId: string, options?: RawAxiosRequestConfig) {
        return RestUserQuizApiFp(this.configuration).getUserQuizzes(userId, quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary initialize user quiz
     * @param {string} userId 
     * @param {string} quizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApi
     */
    public initializeUserQuiz(userId: string, quizId: string, options?: RawAxiosRequestConfig) {
        return RestUserQuizApiFp(this.configuration).initializeUserQuiz(userId, quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update quiz connection time
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizApi
     */
    public updateQuizConnectionTime(userId: string, userQuizId: string, options?: RawAxiosRequestConfig) {
        return RestUserQuizApiFp(this.configuration).updateQuizConnectionTime(userId, userQuizId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetUserQuizQuestionPositionEnum = {
    Current: 'CURRENT',
    Next: 'NEXT'
} as const;
export type GetUserQuizQuestionPositionEnum = typeof GetUserQuizQuestionPositionEnum[keyof typeof GetUserQuizQuestionPositionEnum];
